
import ModelBase from "../../../../framework/core/mvvm/model_base";
import * as RoomProto from "../../net/proto/proto_bullbull_room";
import * as GameProto from "../../net/proto/proto_bullbull_game";
import Msg from "../../net/bullbull_net_msg_data_game";
import TableBaseModel from "../../../table/module/table_base/table_base_model";

const { ccclass, property } = cc._decorator;

@ccclass
export default class BankerBullBullTableModel extends TableBaseModel
{
    constructor(){
        super();
    }

    
    //离开房间请求
    request_leave_room(){
        let protoData: RoomProto.BullBullRoom.ILeaveReq = {};
        this.sendMsg(Msg.LeaveRoom, protoData)
    }

    /**
     * 继续游戏
     */
    request_continute(){
        
        let protoData : RoomProto.BullBullRoom.IReadyReq = { isReady : 1};
        this.sendMsg(Msg.ReadyInfo, protoData)
    }

    /**
     * 比牌请求
     */
    requset_computePoker(){

        let protoData : GameProto.BullBullGame.IComputePokerReq = {};
        this.sendMsg(Msg.ComputePoker,protoData);
    }

    /**
     * 
     * @param betType 倍数选择 
     */
    requset_bet(betType : number){

        let protoData : GameProto.BullBullGame.IBetReq = {betType};
        this.sendMsg(Msg.BetInfo,protoData);
    }

    request_banker(type : number){

        let protoData : GameProto.BullBullGame.IScrambleBankerReq = { isScramble : type > 0 , multiple : type};
        this.sendMsg(Msg.ScrambleBanker,protoData);
    }

    //请求历史数据
    request_history_result(){
        // let protoData: ProtoGame.LongHuDou.IBetResultHistory = {
        // }
        // this.sendMsg(NetMsgData.GetHistoryResult, protoData)
    }

    request_ackId(ackId : number){

        let protoData : GameProto.BullBullGame.IAckReq = {ackId};
        this.sendMsg(Msg.Ack,protoData);
    }
    


}
